import { Button } from "@gigpro/ui/Button";
import { Dialog, DialogFooter, DialogTitle } from "@gigpro/ui/Dialog";
import { JobsTrialStepContainer } from "domains/hire/containers/JobsTrialStep";
import { ResubscribeDialog } from "domains/hire/containers/ResubscribeDialog";
import { useJobsGateState } from "domains/hire/hooks/useJobsGateState";
import type { JobsGate } from "domains/hire/jobsPlan";

type JobsGateDialogsProps = {
  locationId: number;
  /** The gate the person ran into, or null while nothing is open. */
  open: JobsGate | null;
  onClose: () => void;
};

/** What each gate opens: the trial step, Resubscribe, or a note to ask an admin. */
export const JobsGateDialogs = ({ locationId, open, onClose }: JobsGateDialogsProps) => {
  const { location, status } = useJobsGateState(locationId);
  return (
    <>
      <Dialog open={open === "trial"} onClose={onClose}>
        <DialogTitle className="sr-only">Start your free trial</DialogTitle>
        <JobsTrialStepContainer
          locationId={locationId}
          submitLabel="Start free trial"
          saveSubmitLabel="Save and start free trial"
          purpose="unlock"
          onStarted={() => Promise.resolve(onClose())}
          onBack={onClose}
        />
      </Dialog>
      {location && status && (
        <ResubscribeDialog
          open={open === "resubscribe"}
          onClose={onClose}
          locationId={locationId}
          locationName={location.name}
          status={status}
        />
      )}
      <Dialog open={open === "askAdmin"} onClose={onClose}>
        <DialogTitle>Ask an admin</DialogTitle>
        <p className="px-6 text-normal text-gray">
          Ask an admin{location && ` at ${location.name}`} to{" "}
          {status?.can_start_trial ? "start the free trial" : "resubscribe"} and see who applied.
        </p>
        <DialogFooter>
          <Button variant="contained" onClick={onClose}>
            Got it
          </Button>
        </DialogFooter>
      </Dialog>
    </>
  );
};
